import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import StringUtils from '../utils/string';

const NetworkSearch = ({ initialUsers = [], onTokenChange }) => {

  const typeaheadRef = useRef(null);

  useEffect(() => {
    setup();
  }, []);

  useEffect(() => {
    if (!hasBeenSetup()) {
      setup();
    }
  });

  const hasBeenSetup = () => {
    return !!$(typeaheadRef.current).data('bs.tokenfield');
  }

  const setup = () => {
    const prePopulatedUsers = $.map(initialUsers, function(user) {
      return $.extend({}, user, { id: user.id, value: user.id, label: user.displayName });
    });

    $(typeaheadRef.current).tokenfield({
      typeahead: [{
        minLength: 2
      }, {
        display: 'display_name',
        limit: Infinity,
        source: window.suggestionEngines.network,
        templates: {
          suggestion: networkOptionDisplay,
          notFound: '<div class="t3 tt-not-found">No users found</div>',
          pending: '<div class="t3 tt-loading">Searching...</div>'
        }
      }]
    }).on('tokenfield:createtoken', function(event) {
      const $typeaheadInput = $(this);
      const existingTokens = $typeaheadInput.tokenfield('getTokens');

      //don't add non-typeahead items
      if (typeof event.attrs.id === 'undefined') {
        event.preventDefault();
        return;
      }

      //de-dup tokens
      const container = $typeaheadInput.parent();
      $.each(existingTokens, (index, token) => {
        if (event.attrs.value === token.value) {
          $(`.token:eq(${index})`, container).hide().fadeIn();
          $('.tt-input', container).typeahead('val', '');
          event.preventDefault();
          return;
        }
      });
    }).on('tokenfield:createdtoken tokenfield:removedtoken', handleTokenChange)
      .on('tokenfield:edittoken', () => { return false; })
      .tokenfield('setTokens', prePopulatedUsers, false);

    $(document).on('typeahead:render', function(event) {
      const $input = $(event.target).closest('.tokenfield');
      const inputWidth = $input.width();
      const paddingLeft = parseInt($input.css('padding-left').replace('px', ''), 10);
      const typeaheadWidth = $('.twitter-typeahead', $input).outerWidth();
      const offset = (inputWidth + paddingLeft) - typeaheadWidth;

      $('.tt-menu').css({ left: `${-offset}px` });
    });
  }

  const handleTokenChange = () => {
    const networkTokens = $(typeaheadRef.current).tokenfield('getTokens');
    onTokenChange(networkTokens);
  }

  const networkOptionDisplay = option => {
    return `<div class="clearfix">
      <div class="head-shot pull-left">
        <div class="head-shot-clip">
          <img src="${option.headshot_url}" width='35' alt="${option.display_name}" />
        </div>
      </div>
      <div class="participant-info">
        <p class="t3 w3">${option.display_name}</p>
        <p class="t5 mr-50">${option.company_title || ''}</p>
      </div>
    </div>`;
  }

  return (
    <input type="text"
           className="t3 typeahead form-control"
           placeholder="Type user's name or email"
           ref={typeaheadRef} />
  );
}

NetworkSearch.propTypes = {
  onTokenChange: PropTypes.func.isRequired
};

export default NetworkSearch;
